// extracted by css-extract-rspack-plugin
export default {"pluginList":"gsbrM"};